window.addEventListener('DOMContentLoaded',function () 
{

    // wenn die Auswahl vollständig ist
    var wrap = document.getElementById('buy-buttons-wrapper');
    if(wrap){ wrap.classList.remove('hidden'); }
    

    var image_click = document.querySelectorAll(".color_image");
    for (let i = 0; i < image_click.length; i++) 
    {
        const single_image_click = image_click[i];
        single_image_click.addEventListener("click",function()
        {
           $('.color_item:first').addClass('active_selection');
           $('.color_selection_overlay').addClass('active');
           $('.color_selection_popup').addClass('active');
        });
    }

    var display_image_click = document.querySelectorAll(".display_color_image");
    for (let i = 0; i < display_image_click.length; i++) 
    {
        const single_image_click = display_image_click[i];
        single_image_click.addEventListener("click",function()
        {
           $('.color_selection_overlay').addClass('active');
           $('.color_selection_popup').addClass('active');
           var select_color= $('.done').length;
           var color_item= $('.color_item').length;
           $('.selected_number_of_value').text(select_color + ' von ' + color_item + ' ausgewählt');
           $('.color_selection_popup').css('top', $(window).scrollTop());
        });
    }
    

    function fillProgressBar()
    {
        var select_color= $('.done').length;
        var base_number = parseFloat(100 / $('.color_section .color_section_wrapper .color_item').length);
        var progressbar_fill= $('.wi_progressbar_fill');
        $(progressbar_fill).css('width',base_number * select_color +'%');
        var total_width= base_number * select_color +'%';
        // console.log('total_width::: ', total_width);

        
        if (total_width == '100%')
        {
            $('.wi_progressbar_fill').css("background-color", "#53ac34");    
            $('.wi_progressbar_container').css("border", "1px solid #53ac34");    
        }
        else
        {
            $('.wi_progressbar_fill').css("background-color", "#000000");
            $('.wi_progressbar_container').css("border", "1px solid #000000");    
        }
    }

    function closePopup()
    {
        var select_color= $('.done').length;
        var color_item= $('.color_item').length;
        if (select_color == color_item)
        {
            $('.color_selection_overlay').removeClass('active'); 
            $('.color_selection_popup').removeClass('active'); 
            $('.choose_style_button').addClass('hidden');
            $('.custom_product_buy_buttons').removeClass('hidden');
            $('.sticky-choose_style_button').addClass('hidden');
        }
    }

    function fillOriginalSelection(nail_image_src, nail_color_name, i) 
    {   
        $('.display_color_item:nth-child('+ i +') p').text(nail_color_name);
        $('.display_color_item:nth-child('+ i +') img').attr('src', nail_image_src);
        $('.display_color_item:nth-child('+ i +') .display_color_image').addClass('selected');
        $('.display_color_item:nth-child('+ i +') .hidden_color_name').val(nail_color_name);
    }

    function selectedNumberOfValue()
    {
        var select_color= $('.done').length;
        var color_item= $('.color_item').length;
        $('.selected_number_of_value').text(select_color + ' von ' + color_item + ' ausgewählt');
        if (select_color == color_item)
        {
            $('.selected_number_of_value').css("color", "#53ac34");
            $('.choose_color_title p').text("Tolle Auswahl!!");
            $('.choose_color_title p').css("color", "#53ac34");
            $('.choose_color_title h5').text("Gute Wahl! Das sind deine " + color_item + " Farben:");
            $('.choose_color_title h5').css("color", "#53ac34");
            $('.choose_style_button').removeClass('hidden');
            $('.custom_product_buy_buttons').addClass('hidden');
            $('.sticky-choose_style_button').removeClass('hidden');
        }
        else
        {
            $('.selected_number_of_value').css("color", "#000000");
            $('.choose_color_title p').text("Wähle deine " + color_item + " Farben");
            $('.choose_color_title p').css("color", "#000000");
            $('.choose_color_title h5').text("Wähle deine " + color_item + " Farben");
            $('.choose_color_title h5').css("color", "#000000");
        }
    } 

    /* $(".single_nail_color_wrapper").on("click",function() 
    {
        var nail_image_src= $(this).find(".nail_color_image img").attr('src');
        var selected_nail_image= $('.color_image');
        var nail_color_name= $(this).find('.nail_color_name p').text();

        for (let i = 0; i < selected_nail_image.length; i++) 
        {
            const single_nail_image = selected_nail_image[i];
            var target_image= $(single_nail_image).find('img');
            var image_src= $(target_image).attr('src');
            if (image_src == '') 
            {
                $(single_nail_image).addClass('active');
                $(single_nail_image).find('img').attr('src', nail_image_src);
                $(target_image).parents('.color_item').addClass('done').removeClass('active_selection');
                $(target_image).parents('.color_item').next().addClass('active_selection');
                
                fillOriginalSelection(nail_image_src, nail_color_name, i+1);
                selectedNumberOfValue();
                setTimeout(() => {
                    $(single_nail_image).parents('.done').find('.color_name p').text(nail_color_name);                
                    fillProgressBar();
                    closePopup();
                    nailSelectionCompleted();
                    setColorPropertiesFromSlots(); // neu
                }, 200);
                return false;
            }
            
        }
        
    }); */

    // Sicherheit: erst alle jQuery-Click-Handler auf diesen Kacheln entfernen,
// dann genau EINEN eigenen hinzufügen
$(".single_nail_color_wrapper").off("click").on("click.colorpicker", function(e) {
    e.preventDefault();
    e.stopPropagation();

    var nail_image_src = $(this).find(".nail_color_image img").attr('src');
    var selected_nail_image = $('.color_image');
    var nail_color_name = $(this).find('.nail_color_name p').text();

    for (let i = 0; i < selected_nail_image.length; i++) {
        const single_nail_image = selected_nail_image[i];
        var target_image = $(single_nail_image).find('img');
        var image_src = $(target_image).attr('src');

        if (image_src == '') {
            $(single_nail_image).addClass('active');
            $(single_nail_image).find('img').attr('src', nail_image_src);
            $(target_image).parents('.color_item').addClass('done').removeClass('active_selection');
            $(target_image).parents('.color_item').next().addClass('active_selection');
            
            fillOriginalSelection(nail_image_src, nail_color_name, i + 1);
            selectedNumberOfValue();

            setTimeout(() => {
                $(single_nail_image).parents('.done').find('.color_name p').text(nail_color_name);
                fillProgressBar();
                closePopup();
                nailSelectionCompleted();
                setColorPropertiesFromSlots();
            }, 200);

            return false; // Schleife abbrechen, nur EIN Slot füllen
        }
    }
});

    function removeOriginalSelection(i, color_name)
    {
        $('.display_color_item:nth-child('+ i +') img').attr('src', '');
        $('.display_color_item:nth-child('+ i +') p').text(color_name);
        $('.display_color_item:nth-child('+ i +') .display_color_image').removeClass('selected');
        $('.display_color_item:nth-child('+ i +') .hidden_color_name').val('');
    }

    $(".close_icon").on("click",function(e) 
    {   
        e.stopPropagation();
        $('.color_item').removeClass('active_selection');
        $(this).parents('.color_image').find('img').attr('src', '');
        $(this).parents('.color_image').removeClass('active');
        $(this).parents('.color_item').removeClass('done');
        var color_name=  $(this).parents('.color_item').find('.color_name p').attr('data-color-name');
        $(this).parents('.color_item').find('.color_name p').text(color_name); 
        var selected_nail_image= $('.color_image');
        for (let i = 0; i < selected_nail_image.length; i++) 
        {
            const single_nail_image = selected_nail_image[i];
            var color_name=  $(single_nail_image).parents('.color_item').find('.color_name p').attr('data-color-name');
            var target_image= $(single_nail_image).find('img');
            var image_src= $(target_image).attr('src');
            selectedNumberOfValue();
            if (image_src == '') 
            {        
                removeOriginalSelection(i+1, color_name);
                fillProgressBar();
            }
        }

        for (let i = 0; i < selected_nail_image.length; i++) 
        {
            const single_nail_image = selected_nail_image[i];
            var target_image= $(single_nail_image).find('img');
            var image_src= $(target_image).attr('src');
            $('.choose_style_button').removeClass('hidden');
            $('.custom_product_buy_buttons').addClass('hidden');
            $('.sticky-choose_style_button').removeClass('hidden');
            if (image_src == '') 
            {
                     
                $(target_image).parents('.color_item:first').addClass('active_selection');
                setTimeout(() => 
                {      
                    fillProgressBar();
                }, 200);
                return false;
            }
        }
        setColorPropertiesFromSlots();
    });

    $(".display_color_image .close_icon").on("click",function() 
    {   
        var close_click= $(this).attr('data-close-records');
        var trigger_close_icon= $('.color_section_wrapper .done:nth-child('+ close_click + ') .close_icon');
        $(trigger_close_icon).trigger('click');
    });

    $(".svg_close_icon").on("click",function(e) 
    {
        $('.color_selection_overlay').removeClass('active');
        $('.color_selection_popup').removeClass('active');
    });

    $(".color_selection_overlay").on("click",function(e) 
    {   
        $('.color_selection_overlay').removeClass('active');
        $('.color_selection_popup').removeClass('active');
    });

    $(".filter_name").on("click",function(e) 
    {
        e.stopPropagation();
        var filter_name= $(this).attr('data-filter-name');
        $('.filter_name p').removeClass('active');
        $(this).find('p').addClass('active');
        if (filter_name == "alle") 
        {
            $('.single_nail_color_wrapper').show();
        }
        else
        {
            $('.single_nail_color_wrapper').hide();
            $('.'+ filter_name).show();
        }
    });

    $(".choose_style_button").on("click",function(e) 
    {
        $('.color_selection_overlay').addClass('active');
        $('.color_selection_popup').addClass('active');
        $('.color_selection_popup').css('top', $(window).scrollTop());
    });
    
    $(".zoom_icon").on("click",function(e) 
    {
        e.stopPropagation();
        var image_src= $(this).parents('.nail_color_image').find('img').attr('src');
        console.log('image_src::: ', image_src);
        $('.zoom_nail_image_overlay').addClass('zoom_image');
        $('.zoom_nail_image_overlay img').attr('src', image_src );
    });
    
    $(".close_zoom_image").on("click",function(e) 
    {
        $('.zoom_nail_image_overlay').removeClass('zoom_image');
    });
    
    
});

function initColorSlider() {
  var $wrap = $('.wi_filter_wrapper');
  if ($wrap.length && !$wrap.hasClass('slick-initialized')) {
    $wrap.slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Prev"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 448 512"><path fill="currentColor" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 448 512"><path fill="currentColor" d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5 12.5-32.8 12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0 32 14.3 32 32l306.7 0L233.4 393.4c12.5 12.5 12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg></button>'
    });
  }
}
document.addEventListener('DOMContentLoaded', initColorSlider);
document.addEventListener('shopify:section:load', initColorSlider);
document.addEventListener('shopify:section:reorder', initColorSlider);

$(document).on('click','[data-open-color-popup="true"]',function(e){
  e.preventDefault();
  $('.color-popup').addClass('is-open'); // deine Klasse prüfen
  initColorSlider();
});

function nailSelectionCompleted() {
  var buyWrap = document.querySelector('.custom_product_buy_buttons');
  var chooseBtn = document.querySelector('.choose_style_button');
  if (buyWrap) buyWrap.classList.remove('hidden');
  if (chooseBtn) chooseBtn.classList.add('hidden');
};

// Properties an das aktive Add-to-Cart Formular hängen

/*
  function setColorProperties(selectedColors) {
  var form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  var holder = form.querySelector('#color-properties-holder');
  if (!holder) {
    holder = document.createElement('div');
    holder.id = 'color-properties-holder';
    form.appendChild(holder);
  }

  holder.innerHTML = '';

  // Einzelne Farben
  selectedColors.forEach(function(name, idx) {
    var input = document.createElement('input');
    input.type  = 'hidden';
    input.name  = 'properties[Farbe ' + (idx + 1) + ']';
    input.value = name;
    holder.appendChild(input);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  // Wie viele Farben sind nötig
  var required = parseInt(document.querySelector('#required-colors')?.value || '0', 10);

  // Alle auswählbaren Kacheln im Popup
  var tiles = document.querySelectorAll('.single_nail_color_wrapper');

  // Aktuelle Auswahl
  var selected = [];

  function getName(tile) {
    // Priorität: data-color-name, sonst Text in .nail_color_name
    var attr = tile.getAttribute('data-color-name');
    if (attr && attr.trim().length) return attr.trim();
    var p = tile.querySelector('.nail_color_name');
    return p ? p.textContent.trim() : '';
  }

  function toggleATC() {
    var wrap = document.querySelector('.custom_product_buy_buttons');
    var chooseBtn = document.querySelector('.choose_style_button');
    if (!wrap || !chooseBtn) return;

    if (required && selected.length < required) {
      wrap.classList.add('hidden');
      chooseBtn.classList.remove('hidden');
    } else {
      wrap.classList.remove('hidden');
      chooseBtn.classList.add('hidden');
    }
  }

  tiles.forEach(function (tile) {
    tile.addEventListener('click', function () {
      var name = getName(tile);
      if (!name) return;

      var idx = selected.indexOf(name);

      if (idx === -1) {
        selected.push(name);
        tile.classList.add('is-selected');

        // Wenn begrenzt, immer nur genau so viele aktiv lassen
        if (required && selected.length > required) {
          var removed = selected.shift();
          var old = Array.prototype.find.call(tiles, function (t) {
            return getName(t) === removed;
          });
          if (old) old.classList.remove('is-selected');
        }
      } else {
        selected.splice(idx, 1);
        tile.classList.remove('is-selected');
      }

      // Properties sofort aktualisieren
      setColorProperties(selected);

      // Buttons ein oder aus
      toggleATC();
    });
  });

  // Initialzustand
  toggleATC();
});

*/

// Properties aus den gewählten Slots ins Add-to-Cart Formular schreiben
function setColorPropertiesFromSlots() {
  var form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  var holder = form.querySelector('#color-properties-holder');
  if (!holder) {
    holder = document.createElement('div');
    holder.id = 'color-properties-holder';
    form.appendChild(holder);
  }

  holder.innerHTML = '';

  // Wir gehen die Slots oben durch und lesen den Namen aus
  var selectedSlots = document.querySelectorAll('.color_item.done .color_name p');

  var index = 1;
  selectedSlots.forEach(function(nameEl) {
    var name = nameEl ? nameEl.textContent.trim() : '';
    if (!name) return;

    var input = document.createElement('input');
    input.type  = 'hidden';
    input.name  = 'properties[Farbe ' + index + ']';
    input.value = name;
    holder.appendChild(input);

    index += 1;
  });
}
